var Type = require('./Type');
var Currency = require('./Currency');
var Alignment = require('../../style/Alignment');

/**
 * The BigNumber class represents string formatted number with
 * specific formatting. It provides font and sizing details that
 * can be used by the Styles class.
 *
 * @param {Object} [oConfig] - Configuration object for this BigNumber type
 * @constructor
 */
function BigNumber(oConfig) {
	Type.call(this, oConfig);

	this.displayUnit = oConfig && typeof oConfig.displayUnit === 'boolean' ? oConfig.displayUnit : true;
	this.unit = oConfig ? oConfig.unit : null;
	this.unitProperty = oConfig ? oConfig.unitProperty : null;
	this.delimiter = oConfig ? oConfig.delimiter : false;
	this.scale = oConfig ? oConfig.scale : null;

	/**
	 * Due to default text alignment LTR, we need to invert the
	 * alignment so that it reflects the default number alignment
	 */
	this.alignment = this.alignment === null ? Alignment.horizontal.RIGHT : Alignment.horizontal.LEFT;
}

BigNumber.prototype = Object.create(Type.prototype);
BigNumber.prototype.constructor = BigNumber;

/**
 * Returns the data value of the business object that is bound by
 * this type. If a template is configured, it will automatically fill
 * the template with the values from the business object and returns
 * the processed string.
 *
 * @param {string} property - Name of the property that shall be accessed.
 * @param {Object} oData - Business object that contains the data.
 *
 * @returns {string|number|boolean|null} - The value of the given property after type specific processing.
 * Returns null if no value is present or the value cannot be processed by this type.
 */
BigNumber.prototype.getValue = function(property, oData) {
	var iScale, sResult, sUnit, sValue;

	sValue = oData[property];

	/* Convert number to string for BigNumber conversion */
	if (typeof sValue == 'number') {
		sValue = sValue.toString();
	}

	/* The value must be passed as a string containing only numerical characters with an optional decimal separator */
	if (typeof sValue != 'string' || !sValue.match(/^(-){0,1}[0-9]+(\.[0-9]+)*$/g)) {
		return null;
	}

	sUnit = oData[this.unitProperty] || this.unit;

	/* Apply fixed scale, only if no unitProperty is provided */
	if (!this.unitProperty && typeof this.scale === 'number') {
		iScale = this.scale;
	} else if (this.unitProperty) {
		iScale = Currency.getCurrencyScale(sUnit);
	}

	sResult = this._parseValue(sValue, iScale, this.delimiter);

	if (this.displayUnit) {
		sResult += (sUnit ? ' ' + sUnit : '');
	}

	return sResult;
};

/**
 * Parses a string representation of a numeric value according to the given requirements.
 *
 * @param {string} sValue - String representation of a numeric value
 * @param {number|null} [iScale] - Defines the scale of the numeric value ( >= 0)
 * @param {boolean} [bDelimiter] - Defines if thousand delimiters should be visible in the output
 * @returns {string} - Parsed representation
 * @private
 */
BigNumber.prototype._parseValue = function(sValue, iScale, bDelimiter) {
	var aSplitted, aInteger, i, sDecimal, sInteger, sSign;

	aSplitted = sValue.split('.');
	sInteger = aSplitted[0];
	sDecimal = aSplitted.length > 1 ? aSplitted[1] : '';

	/* Add thousand delimiter to the integer value */
	if (bDelimiter) {

		/* Remove sign before inserting the delimiter */
		aInteger = sInteger.split('');
		sSign = aInteger[0] === '-' ? aInteger.shift() : '';

		sInteger = sSign + aInteger.reduceRight(function(accumulator, currentValue) {
			return currentValue + (accumulator.length % 4 == 3 ? ',' + accumulator : accumulator);
		}, '');
	}

	if (typeof iScale === 'number') {
		if (iScale < sDecimal.length) {
			sDecimal = sDecimal.substring(0, iScale);
		} else {
			for (i = sDecimal.length; i < iScale; i++) {
				sDecimal += '0';
			}
		}
	}

	return sInteger + (sDecimal ? '.' + sDecimal : '');
};

module.exports = BigNumber;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/binding/type/BigNumber.js
// module id = 11
// module chunks = 0